import type { NClientFiltersProvider } from '@app/providers/ClientFiltersProvider/ClientFiltersProvider.types';

export const initialFilterGroups: Array<NClientFiltersProvider.FilterGroups> = [
  {
    id: '8a75d80a-3497-4c20-9369-84c0fdb07332',
    areLastFilterGroups: true,
  },
];
